import { Button, Card, Checkbox, Form, Input, Spin, Typography } from 'antd';
import React, { useState } from 'react';
import { UploadDocumentsBox } from '@/components';
import ZoomImage from '@/components/investorComponents/ZoomImage';
import { getFileSrc } from '@/utils/helpers';
import { useTranslation } from 'react-i18next';
import { Label } from '@/ui';

export const ItemSection = ({ data, handleUpdate, isUpdating }) => {
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const [fileRU, setFileRU] = useState(null);
  const [fileLV, setFileLV] = useState(null);
  const [value, setValue] = useState(
    data.type === 'boolean' ? JSON.parse(data.text) : (data.text ?? '')
  );
  const [valueRU, setValueRU] = useState(data.text_RU ?? '');
  const [valueLV, setValueLV] = useState(data.text_LV ?? '');

  const onUpdate = (property) => {
    handleUpdate({
      id: data.id,
      ...((property === 'all' || property === 'text') && {
        text:
          data.type === 'text'
            ? value
            : data.type === 'boolean'
              ? value.toString()
              : data.type === 'image' && file && file[0]
                ? file[0].name
                : '-'
      }),
      ...((property === 'all' || property === 'text_RU') && {
        text_RU:
          data.type === 'text'
            ? valueRU
            : data.type === 'boolean'
              ? valueRU.toString()
              : data.type === 'image' && fileRU && fileRU[0]
                ? fileRU[0].name
                : '-'
      }),
      ...((property === 'all' || property === 'text_LV') && {
        text_LV:
          data.type === 'text'
            ? valueLV
            : data.type === 'boolean'
              ? valueLV.toString()
              : data.type === 'image' && fileLV && fileLV[0]
                ? fileLV[0].name
                : '-'
      }),
      type: data.type,
      ...(data.type === 'image' && {
        file:
          property === 'all' || property === 'text'
            ? file[0]
            : property === 'text_RU'
              ? fileRU[0]
              : property === 'text_LV'
                ? fileLV[0]
                : null
      })
    }).then(() => {
      if (file) setFile(null);
      if (fileRU) setFileRU(null);
      if (fileLV) setFileLV(null);
    });
  };

  return (
    <Card style={{ marginBottom: 15 }}>
      {isUpdating ? (
        <Spin />
      ) : (
        <Form layout={data.type === 'text' ? 'horizontal' : 'vertical'}>
          {data.type === 'text' && (
            <>
              <Label $marginBottom={15}>{data.title}</Label>
              <Form.Item label='EN'>
                <Input value={value} onChange={(e) => setValue(e.currentTarget.value)} />
              </Form.Item>
              <Form.Item label='RU'>
                <Input value={valueRU} onChange={(e) => setValueRU(e.currentTarget.value)} />
              </Form.Item>
              <Form.Item label='LV'>
                <Input value={valueLV} onChange={(e) => setValueLV(e.currentTarget.value)} />
              </Form.Item>

              <Button type='primary' onClick={() => onUpdate('all')}>
                Update
              </Button>
            </>
          )}

          {data.type === 'boolean' && (
            <>
              <Form.Item>
                <Checkbox checked={value} onChange={(e) => setValue(e.target.checked)}>
                  {data.title}
                </Checkbox>
              </Form.Item>

              <Button type='primary' onClick={() => onUpdate('all')}>
                Update
              </Button>
            </>
          )}

          {data.type === 'image' && (
            <>
              {data.title !== 'privacy policy' && (
                <>
                  <Label $marginBottom={15}>{data.title}</Label>
                  <Form.Item label={data.title === 'privacy policy' ? 'EN:' : ''}>
                    <UploadDocumentsBox
                      docs={file}
                      setDocs={(files) =>
                        Array.isArray(files) ? setFile(files) : setFile(files ? [files] : [])
                      }
                    />
                  </Form.Item>

                  {data.text && <ZoomImage image={data.text} />}

                  <Button type='primary' disabled={!file} onClick={() => onUpdate('all')}>
                    Update
                  </Button>
                </>
              )}
              {data.title === 'privacy policy' && (
                <>
                  <Form.Item label={'EN:'}>
                    <UploadDocumentsBox
                      docs={file}
                      setDocs={(files) =>
                        Array.isArray(files) ? setFile(files) : setFile(files ? [files] : [])
                      }
                    />
                  </Form.Item>
                  <div style={{ marginBottom: '15px' }}>
                    <Typography.Link href={getFileSrc(data.text)} target='_blank'>
                      {t('File (EN)')}
                    </Typography.Link>
                  </div>
                  <Button
                    type='primary'
                    disabled={!file}
                    onClick={() => onUpdate('text')}
                    style={{ marginBottom: '10px' }}
                  >
                    Update
                  </Button>
                  <Form.Item label={'RU:'}>
                    <UploadDocumentsBox
                      docs={fileRU}
                      setDocs={(files) =>
                        Array.isArray(files) ? setFileRU(files) : setFileRU(files ? [files] : [])
                      }
                    />
                  </Form.Item>
                  <div style={{ marginBottom: '15px' }}>
                    <Typography.Link href={getFileSrc(data.text_RU)} target='_blank'>
                      {t('File (RU)')}
                    </Typography.Link>
                  </div>
                  <Button
                    type='primary'
                    disabled={!fileRU}
                    onClick={() => onUpdate('text_RU')}
                    style={{ marginBottom: '10px' }}
                  >
                    Update
                  </Button>
                  <Form.Item label={'LV:'}>
                    <UploadDocumentsBox
                      docs={fileLV}
                      setDocs={(files) =>
                        Array.isArray(files) ? setFileLV(files) : setFileLV(files ? [files] : [])
                      }
                    />
                  </Form.Item>
                  <div style={{ marginBottom: '15px' }}>
                    <Typography.Link href={getFileSrc(data.text_LV)} target='_blank'>
                      {t('File (LV)')}
                    </Typography.Link>
                  </div>
                  <Button type='primary' disabled={!fileLV} onClick={() => onUpdate('text_LV')}>
                    Update
                  </Button>
                </>
              )}
            </>
          )}
        </Form>
      )}
    </Card>
  );
};
